import React from 'react'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import Page from 'organization/Event/TemplateEditor/Page'
import EventOfflinePage from 'Event/EventOfflinePage'

export default function EventOfflinePageConfig() {
  return (
    <DesignBreadcrumbs page="Offline">
      <Page>
        <EventOfflinePage isPreview />
      </Page>
    </DesignBreadcrumbs>
  )
}
